/**
 * End-of-chat rating for Sonic Advisor: 1-5 stars and an optional comment.
 *
 * GlobalCopilotPanel shows the card once a chat goes quiet: the last message is a
 * finished answer and nothing happens for RATING_IDLE_MS. It asks once per chat.
 * Rating or skipping is remembered on this device, and a saved rating comes back
 * with the session (session.rating) from the API.
 */

export const RATING_IDLE_MS = 30000;
export const RATING_COMMENT_MAX = 500;

const HANDLED_KEY = "pivony_advisor_rating_handled_v1";
const HANDLED_LIMIT = 200;

const waitsForChoice = (msg) =>
  Boolean(
    msg.dashboardPicker || msg.periodPicker || msg.kpiMetricPicker || msg.kpiTeamPicker
  );

/** True when a finished answer ends the chat and the user is not writing. */
export const ratingPromptReady = ({ session, loading, draft }) => {
  if (!session || session.messagesLoaded === false || session.rating || loading) {
    return false;
  }
  if (String(draft || "").trim()) return false;
  const list = Array.isArray(session.messages) ? session.messages : [];
  const last = list[list.length - 1];
  if (!last || last.role !== "assistant" || last.streaming || last.isPlainText) {
    return false;
  }
  if (waitsForChoice(last)) return false;
  return list.some((msg) => msg && msg.role === "user");
};

/** A new question drops an untouched or finished card; a half-filled one stays. */
export const ratingCardAfterQuestion = (card) =>
  card &&
  card.status !== "thanks" &&
  (card.stars > 0 || String(card.comment || "").trim())
    ? card
    : null;

const readHandled = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(HANDLED_KEY) || "{}");
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch (_) {
    return {};
  }
};

export const ratingHandled = (sessionId) =>
  Boolean(sessionId) && Boolean(readHandled()[sessionId]);

/** Keeps the latest HANDLED_LIMIT chats. */
export const rememberRatingHandled = (sessionId) => {
  if (!sessionId) return;
  try {
    const handled = readHandled();
    handled[sessionId] = Date.now();
    const ids = Object.keys(handled).sort(
      (a, b) => (Number(handled[a]) || 0) - (Number(handled[b]) || 0)
    );
    ids.slice(0, Math.max(0, ids.length - HANDLED_LIMIT)).forEach((id) => {
      delete handled[id];
    });
    localStorage.setItem(HANDLED_KEY, JSON.stringify(handled));
  } catch (_) {}
};
